import { render, staticRenderFns } from "./xinyan-spray.vue?vue&type=template&id=35cb898a&scoped=true"
import script from "./xinyan-spray.vue?vue&type=script&lang=js"
export * from "./xinyan-spray.vue?vue&type=script&lang=js"
import style0 from "./xinyan-spray.vue?vue&type=style&index=0&id=35cb898a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb898a",
  null
  
)

export default component.exports